{
  "_provenance": {
    "ns": "validation",
    "source": "the family form renderer’s validation messages: components/apply/validationMessages.ts, read by pages/apply/ApplicationWizard.tsx and components/apply/EligibilityCheck.tsx (#2109 R2 lane L3). The English mirrors lib/intakeFields.ts FIELD_FORMATS / fieldValueProblem and lib/dateRules.ts word for word."
  },
  "date": {
    "after": "This is after {{other}} — please check both dates.",
    "before": "This is before {{other}} — please check both dates.",
    "future": "This date is in the future — please check it.",
    "invalid": "Enter a valid date.",
    "past": "This date is in the past — please check it.",
    "yearBetween": "Enter a year from {{min}} to {{max}}."
  },
  "field": {
    "required": "This question is required."
  },
  "format": {
    "email": "Enter a valid email address.",
    "phone": "Enter a valid phone number.",
    "zip": "Enter a valid ZIP / postal code."
  },
  "number": {
    "atLeast": "Enter {{min}} or more.",
    "atMost": "Enter {{max}} or less.",
    "between": "Enter a value between {{min}} and {{max}}.",
    "wholeBetween": "Enter a whole number from {{min}} to {{max}}."
  },
  "summary": {
    "description_one": "{{count}} question on this page needs a look — it’s marked below.",
    "description_other": "{{count}} questions on this page need a look — they’re marked below.",
    "title": "A few questions need attention"
  }
}
